import type { UserRoleEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "roles";

const URLS = {
  create: BASE_URL,
  update: BASE_URL,
  delete: (serviceCategoryId: UserRoleEntity.Schema["id"]) =>
    [BASE_URL, serviceCategoryId].join(SLASH),
  get: (serviceCategoryId: UserRoleEntity.Schema["id"]) =>
    [BASE_URL, serviceCategoryId].join(SLASH),
  getAll: BASE_URL,
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
